<div (click)="interceptClickEvent($event)" class="platform-menu">
  <a
    [href]="getHomeLink().startsWith('https://') ? getHomeLink() : null"
    class="platform-menu__top"
  >
    <tux-svg [src]="demandscienceLogo" class="platform-menu__svg"></tux-svg>
    <div class="platform-menu__title">DemandScience Home</div>
  </a>
  <hr class="platform-menu__break" />
  <div
    *ngFor="let platformSection of platformData; let last = last"
    class="platform-menu__section"
  >
    <ul class="platform-menu__list">
      <li
        *ngFor="let platformItem of platformSection.items"
        [style.opacity]="platformItem.disabled ? 0.5 : 1"
        [style.pointer-events]="platformItem.disabled ? 'none' : 'all'"
        class="platform-menu__list-item"
      >
        <ng-container *ngIf="platformItem | isNavLink">
          <a
            *ngIf="
              platformItem?.path &&
              platformItem.path.startsWith('http') &&
              (platformItem | hideNavItems)
            "
            [href]="getHref(platformItem.path)"
            (click)="onNavItemClick()"
          >
            <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
          </a>
          <a
            *ngIf="
              platformItem?.path &&
              !platformItem.path.startsWith('http') &&
              (platformItem | hideNavItems)
            "
            [routerLink]="[platformItem.path]"
            (click)="onNavItemClick()"
          >
            <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
          </a>
          <div
            *ngIf="platformItem | hasSubNavItems"
            (mouseenter)="onMouseEnter(platformItem)"
            (mouseleave)="onMouseLeave(platformItem)"
          >
            <div class="group_item">
              <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
            </div>
            <fa-icon
              [icon]="faCaretRight"
              class="platform-menu__icon"
            ></fa-icon>
            <tux-nav-platform-switcher-menu-list
              *ngIf="platformItem.showSubNav"
              [items]="platformItem.items"
            >
            </tux-nav-platform-switcher-menu-list>
          </div>
          <ng-template #navItemContent>
            <fa-icon
              *ngIf="platformItem.icon"
              [icon]="platformItem.icon"
              class="platform-menu__icon"
            ></fa-icon>
            <span class="platform-menu__text">{{ platformItem.text }}</span>
          </ng-template>
        </ng-container>
      </li>
    </ul>
    <hr *ngIf="!last" class="platform-menu__break" />
  </div>
</div>
